<template>
  <div class="product-form-field-select">
    <label class="text-base font-bold mb-4 block" :for="$attrs.id">
      <slot name="label" />
    </label>
    <DrSelect :placeholder="placeholder" v-bind="$attrs" :value="value" v-on="listeners">
      <slot />
    </DrSelect>
    <div class="help mt-4">
      <p>{{ $attrs.help }}</p>
    </div>
    <slot name="description" />
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: {
      type: [Boolean, String],
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  computed: {
    listeners () {
      return {
        ...this.$listeners,
        input: event => this.$emit('input', event),
      }
    },
  },
}
</script>
